import { ProjectId } from './types'

type ProjectStat = {
  value: string
  label: string
}

type ProjectStatsEntry = {
  projectId: ProjectId
  stats: ProjectStat[]
  claim: string
}

// Headline outcomes rendered on case pages as crawlable, quotable text —
// the numbers mirror the homepage RealProductsRealResults section.
export const PROJECT_STATS: ProjectStatsEntry[] = [
  {
    projectId: ProjectId.WorkAxle,
    stats: [
      { value: '30,000', label: 'users online' },
      { value: '$2.8M CAD', label: 'raised' },
      { value: '<3 years', label: 'from first commit to enterprise' },
    ],
    claim:
      'StartupCraft took WorkAxle from an idea in July 2017 to an enterprise workforce-management platform — 30,000 users online, CAD $2.8M raised, enterprise-ready in under 3 years.',
  },
  {
    projectId: ProjectId.EmajinGolf,
    stats: [
      { value: '72%', label: 'faster time-to-market' },
      { value: '58%', label: 'development cost reduction' },
    ],
    claim:
      'Emajin Golf shipped its member platform 72% faster and at 58% lower development cost than a conventional agency build.',
  },
]
